import { FETCH_CALL_LOGS_IDS_LOADING, FETCH_CALL_LOGS_IDS_SUCCESS, FETCH_CALL_LOGS_IDS_FAILED, CLEAR_CALL_LOGS_IDS_STATUS, CLEAR_CALL_LOGS_IDS_DETAILS } from '../actions/soundManager.action';
import { CallLogsIdsReducer } from '../models/callLogsIds.interface';

const initialState: CallLogsIdsReducer = {
    callLogsIdsLoading: true,
    callLogsIdsError: false,
    callLogsIdsMessage: "",
    callLogsIdsData: [],
    saveLoading: false,
    total: 0,
    totalLogs: 0,
}

const callLogsIdsReducer = (state: CallLogsIdsReducer = initialState, action: any): CallLogsIdsReducer => {
    switch (action.type) {

        case CLEAR_CALL_LOGS_IDS_STATUS:
            return {
                ...state,
                callLogsIdsError: false,
                callLogsIdsMessage: ""
            }
        case FETCH_CALL_LOGS_IDS_LOADING:
            return {
                ...state,
                callLogsIdsLoading: true,
                callLogsIdsError: false,
                callLogsIdsMessage: ""
            }
        case FETCH_CALL_LOGS_IDS_SUCCESS:
            return {
                ...state,
                callLogsIdsLoading: false,
                callLogsIdsData: action.payload.data,
                total: action.payload.total,
                totalLogs: action.payload.total,
            }
        case FETCH_CALL_LOGS_IDS_FAILED:
            return {
                ...state,
                callLogsIdsLoading: false,
                callLogsIdsError: true,
                callLogsIdsMessage: action.payload.error.message || ""
            }
        case CLEAR_CALL_LOGS_IDS_DETAILS:
            return initialState;
        default:
            return state;
    }
}

export default callLogsIdsReducer;
